<template>
  <div id="page-login" class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col lg:block lg:w-full">
              <div class="vx-row no-gutter justify-center items-center">
                <!-- <img src="@/assets/images/no_permission" alt="login" style="height:150px;width:150px;" class="mx-auto"> -->
                <img src="@/assets/images/no_permission.svg" alt="login" style="height:50%;width:75%;object-fit:contain;border:1px solid #ccc;padding:5px;" class="mx-auto">

              </div>
              <h6 class="text-primary text-center" style="text-decoration:underline;" @click="$router.push('/dashboard/analytics')">Go Home</h6>
            </div>
            </div>
    </div>
  </div>
</template>


<script>
// import LoginJwt from './LoginJWT.vue'
// import LoginFirebase from './LoginFirebase.vue'
// import LoginAuth0 from './LoginAuth0.vue'

export default {
  components: {
    // LoginJwt
    // LoginFirebase,
    // LoginAuth0
  }
}
</script>

<style lang="scss">
.login-tabs-container {
  // min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
</style>
